export default {
  model: [
    {
      label: 'Assunto da Newsletter',
      field: 'subject',
      type: 'text'
    },
    {
      label: 'Data Inicial',
      field: 'start_date',
      type: 'text'
    },
    {
      label: 'Data Final',
      field: 'end_date',
      type: 'text'
    },
    {
      label: 'Gerar',
      field: 'content_news',
      type: 'text'
    },
  ]
}